'use client';

var noop = function noop() {};
export { noop };